<template>
  <div :class="['FieldSelect', { error: canShowError }]">
    <field-label v-if="label" :for-id="id">{{ label }}</field-label>
    <div class="field-wrapper">
      <select
        :id="id"
        v-model="field.$model"
        :name="name"
        :class="['field', { error: canShowError, filled: field.$model !== '' }]"
      >
        <option
          v-for="(option, index) of options"
          :key="`options_${index}`"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <icon class="select-arrow" name="angle-down" />
    </div>
    <field-error :show="canShowError">{{ errorMessage }}</field-error>
  </div>
</template>

<script>
import formField from "@mixins/form-field";
import FieldLabel from "@components/form/field-label";
import FieldError from "@components/form/field-error";
import Icon from "@components/atoms/icon";

export default {
  name: "FieldSelect",
  components: { Icon, FieldError, FieldLabel },
  mixins: [formField],
  props: {
    options: { type: Array, required: true }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.field-wrapper {
  position: relative;
}

.field {
  display: block;
  width: 100%;
  background: $color-white;
  border: 1px solid rgba($color-dark, 0.25);
  border-radius: 5px;
  font-size: 16px;
  line-height: normal;
  font-weight: $light;
  height: 40px;
  padding: 0 26px 1px 16px;
  color: rgba($color-grey, 0.75);
  transition: border 0.4s ease-in-out;
  position: relative;
  z-index: 1;

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
    height: 50px;
    padding-right: 32px;
    padding-bottom: 2px;
  }

  &.filled {
    color: $color-dark;
  }

  .error & {
    border-color: $color-error;
  }
}

.select-arrow {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 40px;
  font-size: 16px;

  @media (min-width: $bootstrap-md) {
    width: 32px;
    height: 50px;
    font-size: 20px;
  }
}
</style>
